module.exports = __webpack_public_path__ + "media/images/cms/img_profile-85ef706822784b1ce337813becf3de4c.png";